import React from 'react';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { ReactComponent as BadgeIcon } from '../../../Images/svg/badge-white.svg';
import './AuditoriumBadgeBanner.scss';

class AuditoriumBadgeBanner extends React.Component {
	state = {
		badgeBannerClosed: false,
	};

	handleCloseBadgeBanner = () => {
		this.setState({ badgeBannerClosed: true });
	};

	handleClaimBadge = () => {
		const { toggleBadgeDialog } = this.props;
		if (toggleBadgeDialog) {
			toggleBadgeDialog();
		}
	};

	render() {
		const { badgeBannerClosed } = this.state;
		const {
			timeslot,
			sideNavigation,
			mobile,
			badgeForCurrentTimeslot,
			isLoadingBadgeForCurrentTimeslot,
		} = this.props;

		// User-specific badge ownership check
		const userHasBadgeForTimeslot = !!badgeForCurrentTimeslot;

		// Check if we should display the banner
		// - timeslot has badge banner enabled (displayBadge)
		// - banner was not manually closed
		// - we are not currently loading badge info
		// - user does NOT already own a badge for this timeslot
		const displayBadgeBanner =
			!badgeBannerClosed &&
			!!timeslot?.displayBadge &&
			!isLoadingBadgeForCurrentTimeslot &&
			!userHasBadgeForTimeslot;

		if (!displayBadgeBanner) {
			return null;
		}

		return (
			<div
				className={`badge-banner ${sideNavigation?.isOpened && !mobile ? 'wall-networking-isOpen' : ''}`}
			>
				{mobile ? (
					<>
						<div className="top-text">
							Be Recognized: Get Your Attendance Badge Today!
						</div>
						<div className="bottom-actions">
							<Button
								type="button"
								classes={{ root: 'badge-banner-close' }}
								onClick={this.handleCloseBadgeBanner}
							>
								<CloseIcon />
							</Button>
							<Button
								type="button"
								classes={{ root: 'badge-banner-claim' }}
								onClick={this.handleClaimBadge}
							>
								<BadgeIcon />
								<span>CLAIM ATTENDANCE BADGE</span>
							</Button>
						</div>
					</>
				) : (
					<>
						<div className="left-side">
							<Button
								type="button"
								classes={{ root: 'badge-banner-close' }}
								onClick={this.handleCloseBadgeBanner}
							>
								<CloseIcon />
							</Button>
							Be Recognized: Get Your Attendance Badge Today!
						</div>
						<Button
							type="button"
							classes={{ root: 'badge-banner-claim' }}
							onClick={this.handleClaimBadge}
						>
							<BadgeIcon />
							<span>CLAIM ATTENDANCE BADGE</span>
						</Button>
					</>
				)}
			</div>
		);
	}
}

export default AuditoriumBadgeBanner;
